import { adapter, initialState, State } from './state';
import { createReducer, on, Action } from '@ngrx/store';
import { getAllRatesFailure, getAllRatesRequest, getAllRatesSuccess, getRatesFailure, getRatesRequest,
    getRatesSuccess } from './actions';

export const rateReducer = createReducer(
    initialState,
    on(
        getRatesRequest,
        getAllRatesRequest,
        state => ({
            ...state,
            loading: true,
            error: null
        })
    ),
    on(
        getRatesFailure,
        getAllRatesFailure,
        (state, { error }) => ({
            ...state,
            loading: false,
            error
        })
    ),

    // Get Rates
    on(
        getRatesSuccess,
        getAllRatesSuccess,
        (state, { rates }) => adapter.upsertMany(rates, {
            ...state,
            loading: false,
            error: null,
            total: rates.length
        })
    )
);

export function reducer(state: State, action: Action) {
    return rateReducer(state, action);
}
